import { DismissPayloadType } from 'stash/constants/bridgeMessageTypes';
import { deleteCookie } from 'stash/utils/cookies';
import { cookieNames, sendMessage } from 'stash/utils/native-bridge';
import { dismiss } from 'stash/utils/bridgeMessages';

// The native-context cookies (see `server/middleware/native-auth.js`) are set as session
// cookies with no expiry. On webview dismiss we proactively clear them so the cookie jar
// never carries stale native context across webview sessions on cookie stores that persist
// session cookies (e.g. `WKWebsiteDataStore.default()`). The native host re-sends the
// `Stash-*` headers on the next webview open, so the jar is repopulated naturally then.
const NATIVE_CONTEXT_COOKIES: readonly string[] = [
	cookieNames.NATIVE_PLATFORM,
	cookieNames.NATIVE_APP_VERSION,
	cookieNames.NATIVE_APP_ID,
	cookieNames.NATIVE_THEME,
];

export const deleteNativeContextCookies = (): void => {
	NATIVE_CONTEXT_COOKIES.forEach((name) => deleteCookie(name));
};

/**
 * Clears the native-context cookies, then tells the native host to dismiss this webview.
 *
 * Use this in place of `sendMessage(dismiss(type))` at every webview-dismiss call site so
 * we never forget the cookie cleanup step.
 */
export const dismissWebview = (type: DismissPayloadType): void => {
	deleteNativeContextCookies();
	sendMessage(dismiss(type));
};
